export default class ImageZoom {
    mount({ imageSelector, imageModalSelector }) {
        const $imageZoomModal = selector => selector ? $(selector, $(imageModalSelector)) : $(imageModalSelector);

        const $imageModalImg = $imageZoomModal("#image-zoom-img");

        function hideModal() {
            $imageZoomModal().fadeOut("fast");
            $('body').removeClass('modal-open');
        }

        /* Event handler for when the user clicks _outside_ of the modal - in its shadow - to close it. */
        $imageZoomModal().click(function(evt) {
            if ($(evt.target).hasClass("modal")) {
                hideModal();
            }
        });

        /* Event handler for when the user clicks the Escape button to close the modal. */
        $imageZoomModal().keyup(function(evt) {
            if (evt.keyCode === 27) {
                hideModal();
            }
        });

        $imageZoomModal(".close-button").click(function() {
            hideModal();
        });

        $(imageSelector).each((index, obj) => {
            $(obj).click(() => {
                $('body').addClass('modal-open');
                $imageZoomModal().css("display", "flex");
                $imageModalImg.focus();

                $imageModalImg.attr("src", $(obj).attr("src"));
            })
        });
    }
}



// WEBPACK FOOTER //
// ./themes/docs/static/js/image-zoom.js